import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import createAutocompleteFilter, { normalizeSearchText } from "pages/utils/autocompleteFilter";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import DialogCampanhaMaterial from "./components/DialogCampanhaMaterial";
import DialogCampanhaMaterialAlternativas from "./components/DialogCampanhaMaterialAlternativas";
import DialogCampanhaOfertaCliente from "./components/DialogCampanhaOfertaCliente";
import DialogCampanhaOfertaAlternativas from "./components/DialogCampanhaOfertaAlternativas";
import DialogConfirmarEliminarMaterialCampanha from "./components/DialogConfirmarEliminarMaterialCampanha";
import DialogConfirmarEliminarBeneficioCampanha from "./components/DialogConfirmarEliminarBeneficioCampanha";
import DialogCampanhaRecebimentos from "./components/DialogCampanhaRecebimentos";
import DialogCampanhaResultadoDetalhe from "./components/DialogCampanhaResultadoDetalhe";
import DialogCampanhaResultados from "./components/DialogCampanhaResultados";
import DialogCampanhaRecusarFatura from "./components/DialogCampanhaRecusarFatura";
import DialogCampanhaEmailFabricante from "./components/DialogCampanhaEmailFabricante";
import CampanhaFiltrosClientes from "./components/CampanhaFiltrosClientes";
import CampanhaMateriaisPrincipais from "./components/CampanhaMateriaisPrincipais";
import CampanhaAlternativasGerais from "./components/CampanhaAlternativasGerais";
import CampanhaOfertasCliente from "./components/CampanhaOfertasCliente";
import CampanhaBeneficios from "./components/CampanhaBeneficios";
import DialogProcessarCampanhasFabricante from "./components/DialogProcessarCampanhasFabricante";
import DialogCampanhaInfo from "./components/DialogCampanhaInfo";
import DialogCampanhaConsultaFatura from "./components/DialogCampanhaConsultaFatura";
import DialogCampanhasAlertasEditar from "./components/DialogCampanhasAlertasEditar";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import EmailIcon from "@mui/icons-material/Email";
import DeleteIcon from "@mui/icons-material/Delete";
import ListIcon from "@mui/icons-material/List";
import EditNoteIcon from "@mui/icons-material/EditNote";
import TableViewIcon from "@mui/icons-material/TableView";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const materialLabel = (m) =>
  m?.nome ? `${m.nome} (${m.ref})${Number(m.inativo || 0) === 1 ? " — INATIVO" : ""}` : "";

const campanhaCopiaFilter = createAutocompleteFilter(
  (option) =>
    `${option?.nome ?? ""} ${option?.codigo_campanha ?? ""} ${option?.fabricante ?? ""} ${
      option?.reffabricante ?? ""
    }`
);

const contactoFabricanteFilter = createAutocompleteFilter(
  (option) => `${option?.nome ?? ""} ${option?.email ?? ""} ${option?.telefone ?? ""}`
);

export default function Campanhas() {
  const { showAlert } = useAlert();
  const { temPermissao, userData, temFuncao } = useAuth();

  const [loading, setLoading] = useState(false);

  const isAdminLike =
    temFuncao("Administração") || temFuncao("Informática") || temFuncao("Tesouraria");

  const [data, setData] = useState([]);
  const [linhasVisiveis, setLinhasVisiveis] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [fabricantesVigentes, setFabricantesVigentes] = useState([]);
  const [fabricanteVigenteSelecionado, setFabricanteVigenteSelecionado] = useState(null);
  const [fabricanteVigenteInput, setFabricanteVigenteInput] = useState("");
  const [diagnosticoFabricante, setDiagnosticoFabricante] = useState(null);
  const [processamentosCampanhas, setProcessamentosCampanhas] = useState([]);
  const [openProcessarFabricante, setOpenProcessarFabricante] = useState(false);
  const [refreshAposProcessamento, setRefreshAposProcessamento] = useState(false);

  const [contactos, setContactos] = useState([]);
  const [materiaisCombo, setMateriaisCombo] = useState([]);

  const [fabricanteInput, setFabricanteInput] = useState("");
  const [materialInput, setMaterialInput] = useState("");
  const [alternativaInput, setAlternativaInput] = useState("");
  const [alternativaGeralInput, setAlternativaGeralInput] = useState("");
  const [ofertaInput, setOfertaInput] = useState("");

  const [materiaisCampanha, setMateriaisCampanha] = useState([]);
  const [alternativasPorMaterial, setAlternativasPorMaterial] = useState({});
  const [alternativasGerais, setAlternativasGerais] = useState([]);
  const [ofertasCliente, setOfertasCliente] = useState([]);
  const [alternativasOfertasCliente, setAlternativasOfertasCliente] = useState({});
  const [beneficios, setBeneficios] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [resultadosExcluidos, setResultadosExcluidos] = useState([]);
  const [loadingResultados, setLoadingResultados] = useState(false);

  const [gruposClientes, setGruposClientes] = useState([]);
  const [segmentosClientes, setSegmentosClientes] = useState([]);
  const [clientesCombo, setClientesCombo] = useState([]);
  const [clienteInput, setClienteInput] = useState("");
  const [filtrosCampanha, setFiltrosCampanha] = useState([]);
  const [clientesAcordosCampanha, setClientesAcordosCampanha] = useState([]);
  const [filtroClientesAcordos, setFiltroClientesAcordos] = useState("");
  const [expandedFiltroCliente, setExpandedFiltroCliente] = useState(null);
  const [loadingFiltrosCampanha, setLoadingFiltrosCampanha] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(false);

  const [openCopiarCampanha, setOpenCopiarCampanha] = useState(false);
  const [campanhaOrigemCopia, setCampanhaOrigemCopia] = useState(null);

  const [openConfirmDelCampanha, setOpenConfirmDelCampanha] = useState(false);
  const [campanhaParaEliminar, setCampanhaParaEliminar] = useState(null);

  const [openDialogMaterial, setOpenDialogMaterial] = useState(false);
  const [openDialogAlternativas, setOpenDialogAlternativas] = useState(false);
  const [materialAlternativasSelecionado, setMaterialAlternativasSelecionado] = useState(null);

  const [openDialogOfertaCliente, setOpenDialogOfertaCliente] = useState(false);
  const [openDialogOfertaClienteAlternativas, setOpenDialogOfertaClienteAlternativas] =
    useState(false);
  const [ofertaClienteAlternativasSelecionada, setOfertaClienteAlternativasSelecionada] =
    useState(null);

  const [openConfirmDelMaterial, setOpenConfirmDelMaterial] = useState(false);
  const [materialParaEliminar, setMaterialParaEliminar] = useState(null);

  const [openConfirmDelBeneficio, setOpenConfirmDelBeneficio] = useState(false);
  const [beneficioParaEliminar, setBeneficioParaEliminar] = useState(null);

  const [openResultado, setOpenResultado] = useState(false);
  const [resultadoSelecionado, setResultadoSelecionado] = useState(null);
  const [resultadoLinhas, setResultadoLinhas] = useState([]);
  const [resultadoBeneficios, setResultadoBeneficios] = useState([]);
  const [resultadoRecebimentos, setResultadoRecebimentos] = useState([]);

  const [openRecebimentos, setOpenRecebimentos] = useState(false);
  const [recebimentosLinhas, setRecebimentosLinhas] = useState([]);
  const [historicoRecebimentosCampanha, setHistoricoRecebimentosCampanha] = useState([]);

  const [openResultadosCampanha, setOpenResultadosCampanha] = useState(false);
  const [campanhaResultados, setCampanhaResultados] = useState(null);
  const [periodoResultadosCampanha, setPeriodoResultadosCampanha] = useState({
    datainicial: "",
    datafinal: "",
  });

  const [openRecusarFatura, setOpenRecusarFatura] = useState(false);
  const [faturaParaRecusar, setFaturaParaRecusar] = useState(null);
  const [motivoRecusaFatura, setMotivoRecusaFatura] = useState("");

  const [openDialogEmail, setOpenDialogEmail] = useState(false);
  const [campanhaEmail, setCampanhaEmail] = useState(null);

  const [loadingAnexoEmail, setLoadingAnexoEmail] = useState(false);

  const [soComAlertas, setSoComAlertas] = useState(false);

  const [alertasCampanha, setAlertasCampanha] = useState([]);
  const [filtroResolucaoAlertas, setFiltroResolucaoAlertas] = useState("TODOS");

  const [openEditarAlertas, setOpenEditarAlertas] = useState(false);
  const [alertasTodos, setAlertasTodos] = useState([]);
  const [loadingEditarAlertas, setLoadingEditarAlertas] = useState(false);

  const [openInfoCampanha, setOpenInfoCampanha] = useState(false);
  const [campanhaInfo, setCampanhaInfo] = useState(null);

  const [loadingInfoCampanha, setLoadingInfoCampanha] = useState(false);

  const [openConsultaFatura, setOpenConsultaFatura] = useState(false);
  const [faturaConsulta, setFaturaConsulta] = useState("");
  const [resultadosConsultaFatura, setResultadosConsultaFatura] = useState([]);
  const [loadingConsultaFatura, setLoadingConsultaFatura] = useState(false);

  const [emailForm, setEmailForm] = useState({
    to: "",
    cc: "",
    bcc: "",
    assunto: "",
    mensagem: "",
  });

  const [form, setForm] = useState({
    id: null,
    nome: "",
    codigo_campanha: "",
    reffabricante: "",
    idfabricantecontacto: "",
    datainicial: "",
    datafinal: "",
    enviaremail: 0,
    aceitaclientesparticulares: 0,
    extra_campanha: 0,
    min_refs_distintas: 0,
    estado: "Pendente",
    obs: "",
  });

  const [formMaterial, setFormMaterial] = useState({
    id: null,
    refmaterial: "",
    qtd: 1,
    unidade: "",
    descprommaxfabricante: "",
    obs: "",
  });

  const [formAlternativa, setFormAlternativa] = useState({
    id: null,
    idcampanhamaterial: null,
    refmaterialalternativo: "",
    qtd: 0,
    unidade: "",
    descprommaxfabricante: "",
    fatorequivalencia: 1,
    obs: "",
  });

  const [formAlternativaGeral, setFormAlternativaGeral] = useState({
    id: null,
    refmaterialalternativo: "",
    qtd: 0,
    unidade: "",
    descprommaxfabricante: "",
    fatorequivalencia: 1,
    obs: "",
  });

  const [formOfertaCliente, setFormOfertaCliente] = useState({
    id: null,
    refmaterialoferta: "",
    qtd: 1,
    unidade: "",
    obs: "",
    reembolsada: 0,
  });
  const [formOfertaClienteAlternativa, setFormOfertaClienteAlternativa] = useState({
    id: null,
    idcampanhaoferta: null,
    refmaterialalternativo: "",
    qtd: 0,
    unidade: "",
    obs: "",
  });

  const [formBeneficio, setFormBeneficio] = useState({
    id: null,
    tipobeneficio: "VALOR_FIXO",
    basecalculo: "CONJUNTO",
    valor_eur: "",
    valor_por_unidade: "",
    percentagem: "",
    usar_iec: 0,
    refmaterialgrupo_iec: "",
    refmaterialoferta: "",
    qtdoferta: "",
    unidadeoferta: "",
    aplicaporconjunto: 1,
    limitevalor_eur: "",
    obs: "",
  });

  const [recebimentosForm, setRecebimentosForm] = useState({
    datarecebimento: new Date().toISOString().substring(0, 10),
    docref: "",
    obs: "",
  });

  const carregar = async () => {
    setLoading(true);
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhas", { mostrarExpiradas: 1 })
    );
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setData(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelMateriaisCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesVigentes = async () => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasVigentes", {})
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesVigentes(Array.isArray(payload) ? payload : []);
  };

  const carregarProcessamentosCampanhas = async (reffabricante) => {
    if (!reffabricante) {
      setProcessamentosCampanhas([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasProcessamentos", {
        origem: "FABRICANTE",
        reffabricante,
        limite: 10,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setProcessamentosCampanhas(Array.isArray(payload) ? payload : []);
  };

  const abrirProcessarFabricante = async () => {
    setFabricanteVigenteSelecionado(null);
    setFabricanteVigenteInput("");
    setDiagnosticoFabricante(null);
    setOpenProcessarFabricante(true);

    await carregarFabricantesVigentes();
    setProcessamentosCampanhas([]);
  };

  const carregarDiagnosticoFabricante = async (reffabricante) => {
    if (!reffabricante) {
      setDiagnosticoFabricante(null);
      return;
    }

    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasVigentesFabricante", { reffabricante })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setDiagnosticoFabricante(payload);
    await carregarProcessamentosCampanhas(reffabricante);
  };

  const processarCampanhasFabricante = async () => {
    if (!fabricanteVigenteSelecionado?.ref) {
      showAlert("Seleciona um fabricante.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err, meta] = await handleApi(
      api.post("Campanhas/ProcessarCampanhasFabricante", {
        reffabricante: fabricanteVigenteSelecionado.ref,
        idutilizador: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Processamento preparado.", meta?.severity || "success");

    setRefreshAposProcessamento(true);

    await carregarDiagnosticoFabricante(fabricanteVigenteSelecionado.ref);
    await carregarProcessamentosCampanhas(fabricanteVigenteSelecionado.ref);
  };

  const carregarFabricantes = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantes(Array.isArray(payload) ? payload : []);
  };

  const carregarContactos = async (reffabricante) => {
    if (!reffabricante) {
      setContactos([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesContactos", { reffabricante })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setContactos(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCampanha = async (idcampanha) => {
    if (!idcampanha) {
      setMateriaisCampanha([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriais", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    const lista = Array.isArray(payload) ? payload : [];
    setMateriaisCampanha(lista);

    const paresAlternativas = await Promise.all(
      lista.map(async (m) => {
        const [alts, altErr] = await handleApi(
          api.post("Campanhas/SelCampanhasMateriaisAlternativos", {
            idcampanhamaterial: m.id,
          })
        );

        return [m.id, altErr ? [] : Array.isArray(alts) ? alts : []];
      })
    );

    setAlternativasPorMaterial(Object.fromEntries(paresAlternativas));
  };

  const carregarAlternativasMaterial = async (idcampanhamaterial) => {
    if (!idcampanhamaterial) return;

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriaisAlternativos", { idcampanhamaterial })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativasPorMaterial((p) => ({
      ...p,
      [idcampanhamaterial]: Array.isArray(payload) ? payload : [],
    }));
  };

  const carregarAlternativasGerais = async (idcampanha) => {
    if (!idcampanha) {
      setAlternativasGerais([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriaisAlternativosGerais", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativasGerais(Array.isArray(payload) ? payload : []);
  };

  const carregarOfertasCliente = async (idcampanha) => {
    if (!idcampanha) {
      setOfertasCliente([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasOfertas", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    const lista = Array.isArray(payload) ? payload : [];
    setOfertasCliente(lista);

    const paresAlternativas = await Promise.all(
      lista.map(async (o) => {
        const [alts, altErr] = await handleApi(
          api.post("Campanhas/SelCampanhasOfertasAlternativos", {
            idcampanhaoferta: o.id,
          })
        );

        return [o.id, altErr ? [] : Array.isArray(alts) ? alts : []];
      })
    );

    setAlternativasOfertasCliente(Object.fromEntries(paresAlternativas));
  };

  const guardarOfertaClienteAlternativa = async () => {
    if (!formOfertaClienteAlternativa.idcampanhaoferta) {
      showAlert("Seleciona primeiro a oferta principal.", "warning");
      return;
    }

    if (!formOfertaClienteAlternativa.refmaterialalternativo) {
      showAlert("Indica material alternativo.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formOfertaClienteAlternativa.id,
      idcampanhaoferta: formOfertaClienteAlternativa.idcampanhaoferta,
      refmaterialalternativo: formOfertaClienteAlternativa.refmaterialalternativo,
      qtd: Number(formOfertaClienteAlternativa.qtd),
      unidade: formOfertaClienteAlternativa.unidade,
      obs: formOfertaClienteAlternativa.obs,
    };

    const endpoint = formOfertaClienteAlternativa.id
      ? "Campanhas/UpdCampanhaOfertaAlternativo"
      : "Campanhas/InsCampanhaOfertaAlternativo";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa da oferta gravada.", meta?.severity || "success");

    setOpenDialogOfertaClienteAlternativas(false);
    await carregarOfertasCliente(form.id);
  };

  const carregarGruposClientes = async () => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelEntidadesGruposCampanhasCombo", {})
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setGruposClientes(Array.isArray(payload) ? payload : []);
  };

  const carregarSegmentosClientes = async () => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelSegmentosEntidadesCampanhasCombo", {})
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setSegmentosClientes(Array.isArray(payload) ? payload : []);
  };

  const carregarClientesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelClientesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setClientesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarClientesAcordosCampanha = async (idcampanha, reffabricante) => {
    if (!idcampanha || !reffabricante) {
      setClientesAcordosCampanha([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelClientesAcordosCampanha", {
        idcampanha,
        reffabricante,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setClientesAcordosCampanha(Array.isArray(payload) ? payload : []);
  };

  const carregarFiltrosCampanha = async (idcampanha) => {
    if (!idcampanha) {
      setFiltrosCampanha([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFiltros", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFiltrosCampanha(Array.isArray(payload) ? payload : []);
  };

  const carregarBeneficios = async (idcampanha) => {
    if (!idcampanha) {
      setBeneficios([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasBeneficios", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setBeneficios(Array.isArray(payload) ? payload : []);
  };

  const carregarTodosAlertas = async () => {
    setLoadingEditarAlertas(true);

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasAlertas", {
        resolucao: "TODOS",
      })
    );

    setLoadingEditarAlertas(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlertasTodos(Array.isArray(payload) ? payload : []);
  };

  const abrirEditarAlertas = async () => {
    setOpenEditarAlertas(true);
    await carregarTodosAlertas();
  };

  const carregarAlertasCampanha = async (idcampanha) => {
    if (!idcampanha) {
      setAlertasCampanha([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasAlertas", {
        idcampanha,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlertasCampanha(Array.isArray(payload) ? payload : []);
  };

  const carregarResultados = async (idcampanha, periodo = null) => {
    if (!idcampanha) {
      setResultados([]);
      setResultadosExcluidos([]);
      return;
    }

    if (periodo && (!periodo.datainicial || !periodo.datafinal)) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    if (periodo?.datainicial && periodo?.datafinal && periodo.datainicial > periodo.datafinal) {
      showAlert("A data inicial não pode ser superior à data final.", "warning");
      return;
    }

    setLoadingResultados(true);

    try {
      const [payload, err] = await handleApi(
        api.post("Campanhas/SelCampanhasFaturas", {
          idcampanha,
          datainicial: periodo?.datainicial || null,
          datafinal: periodo?.datafinal || null,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setResultados(Array.isArray(payload) ? payload : []);

      const [payloadExcluidos, errExcluidos] = await handleApi(
        api.post("Campanhas/SelCampanhasFaturasExcluidas", { idcampanha })
      );

      if (errExcluidos) {
        setResultadosExcluidos([]);
        showAlert(errExcluidos, "error");
      } else {
        setResultadosExcluidos(Array.isArray(payloadExcluidos) ? payloadExcluidos : []);
      }
    } finally {
      setLoadingResultados(false);
    }
  };

  useEffect(() => {
    carregar();
    carregarFabricantes();
    carregarMateriaisCombo();
    carregarGruposClientes();
    carregarSegmentosClientes();
    carregarClientesCombo();
  }, []);

  useEffect(() => {
    if (!openProcessarFabricante) return;
    if (!fabricanteVigenteSelecionado?.ref) return;

    const temProcessamentoAtivo = processamentosCampanhas.some((p) =>
      ["Pendente", "Em processamento"].includes(String(p.estado || ""))
    );

    if (refreshAposProcessamento && processamentosCampanhas.length > 0 && !temProcessamentoAtivo) {
      carregar();
      setRefreshAposProcessamento(false);
      return;
    }

    if (!temProcessamentoAtivo && !refreshAposProcessamento) return;

    const timer = setTimeout(() => {
      carregarProcessamentosCampanhas(fabricanteVigenteSelecionado.ref);
    }, 3000);

    return () => clearTimeout(timer);
  }, [
    openProcessarFabricante,
    fabricanteVigenteSelecionado,
    processamentosCampanhas,
    refreshAposProcessamento,
  ]);

  const limparDetalhesCampanha = () => {
    setContactos([]);
    setMateriaisCampanha([]);
    setAlternativasGerais([]);
    setOfertasCliente([]);
    setAlternativasOfertasCliente({});
    setBeneficios([]);
    setOfertaInput("");
    setResultados([]);
    setAlternativasPorMaterial({});
    setResultadoRecebimentos([]);
    setFiltrosCampanha([]);
    setClientesAcordosCampanha([]);
    setClienteInput("");
  };

  const handleOpenNovo = () => {
    setEditando(false);
    limparDetalhesCampanha();
    setFabricanteInput("");

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setForm({
      id: null,
      nome: "",
      codigo_campanha: "",
      reffabricante: "",
      idfabricantecontacto: "",
      datainicial: "",
      datafinal: "",
      enviaremail: 0,
      aceitaclientesparticulares: 0,
      extra_campanha: 0,
      min_refs_distintas: 0,
      estado: "Pendente",
      obs: "",
    });

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      descprommaxfabricante: "",
      fatorequivalencia: 1,
      obs: "",
    });

    setMaterialInput("");
    setAlternativaInput("");
    setAlternativaGeralInput("");

    setOpenDialog(true);
  };

  const handleOpenEditar = async (row) => {
    setEditando(true);
    setOpenDialog(true);
    setLoading(true);

    const [payload, err] = await handleApi(api.post("Campanhas/SelCampanha", { id: row.id }));

    if (err) {
      setLoading(false);
      showAlert(err, "error");
      return;
    }

    await carregarContactos(payload.reffabricante);
    await carregarMateriaisCampanha(payload.id);
    await carregarAlternativasGerais(payload.id);
    await carregarOfertasCliente(payload.id);
    await carregarBeneficios(payload.id);
    await carregarFiltrosCampanha(payload.id);
    await carregarClientesAcordosCampanha(payload.id, payload.reffabricante);
    await carregarResultados(payload.id);

    setForm({
      id: payload.id,
      nome: payload.nome || "",
      codigo_campanha: payload.codigo_campanha || "",
      reffabricante: payload.reffabricante || "",
      idfabricantecontacto: payload.idfabricantecontacto || "",
      datainicial: payload.datainicial ? String(payload.datainicial).substring(0, 10) : "",
      datafinal: payload.datafinal ? String(payload.datafinal).substring(0, 10) : "",
      enviaremail: payload.enviaremail === 1 ? 1 : 0,
      aceitaclientesparticulares: payload.aceitaclientesparticulares === 1 ? 1 : 0,
      extra_campanha: Number(payload.extra_campanha || 0),
      min_refs_distintas: Number(payload.min_refs_distintas || 0),
      estado: payload.estado || "Pendente",
      obs: payload.obs || "",
    });

    setFabricanteInput(
      payload.fabricante ? `${payload.fabricante} (${payload.reffabricante})` : ""
    );

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      descprommaxfabricante: "",
      fatorequivalencia: 1,
      obs: "",
    });

    setOfertaInput("");
    setMaterialInput("");
    setAlternativaInput("");
    setAlternativaGeralInput("");

    setLoading(false);
  };

  const pedirEliminarCampanha = (campanha) => {
    setCampanhaParaEliminar(campanha);
    setOpenConfirmDelCampanha(true);
  };

  const confirmarEliminarCampanha = async () => {
    if (!campanhaParaEliminar?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanha", {
        id: campanhaParaEliminar.id,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Campanha apagada com sucesso.", meta?.severity || "success");

    setOpenConfirmDelCampanha(false);
    setCampanhaParaEliminar(null);

    await carregar();
  };

  const fecharEliminarCampanha = () => {
    setOpenConfirmDelCampanha(false);
    setCampanhaParaEliminar(null);
  };

  const copiarCampanha = async () => {
    if (!campanhaOrigemCopia?.id) {
      showAlert("Seleciona a campanha de origem.", "warning");
      return;
    }

    if (!form.datainicial || !form.datafinal) {
      showAlert("Indica as datas da nova campanha.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err, meta] = await handleApi(
      api.post("Campanhas/CopiarCampanha", {
        idcampanhaorigem: campanhaOrigemCopia.id,
        nome: form.nome,
        codigo_campanha: form.codigo_campanha,
        datainicial: form.datainicial,
        datafinal: form.datafinal,
        extra_campanha: Number(form.extra_campanha || 0),
        criado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Campanha copiada.", meta?.severity || "success");

    setOpenDialog(false);
    await carregar();
  };

  const guardar = async () => {
    if (!form.nome || !form.reffabricante || !form.datainicial || !form.datafinal) {
      showAlert("Preenche nome, fabricante e datas.", "warning");
      return;
    }

    if (editando && beneficios.length === 0) {
      showAlert("Define pelo menos um benefício antes de guardar a campanha.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      ...form,
      idfabricantecontacto: form.idfabricantecontacto || null,
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = editando ? "Campanhas/UpdCampanha" : "Campanhas/InsCampanha";
    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Gravado com sucesso.", meta?.severity || "success");
    setOpenDialog(false);
    await carregar();
  };

  const abrirNovoMaterial = () => {
    setFormMaterial({
      id: null,
      refmaterial: "",
      qtd: 1,
      unidade: "",
      descprommaxfabricante: "",
      obs: "",
    });
    setMaterialInput("");
    setOpenDialogMaterial(true);
  };

  const abrirEditarMaterial = (m) => {
    setFormMaterial({
      id: m.id,
      refmaterial: m.refmaterial || "",
      qtd: m.qtd || 1,
      unidade: m.unidade || "",
      descprommaxfabricante: m.descprommaxfabricante ?? "",
      obs: m.obs || "",
    });

    setMaterialInput(m.material ? `${m.material} (${m.refmaterial})` : "");
    setOpenDialogMaterial(true);
  };

  const fecharDialogMaterial = () => {
    setOpenDialogMaterial(false);
    setMaterialInput("");
    setFormMaterial({
      id: null,
      refmaterial: "",
      qtd: 1,
      unidade: "",
      descprommaxfabricante: "",
      obs: "",
    });
  };

  const guardarMaterial = async () => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formMaterial.refmaterial || Number(formMaterial.qtd) <= 0) {
      showAlert("Indica material e quantidade.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formMaterial.id,
      idcampanha: form.id,
      refmaterial: formMaterial.refmaterial,
      qtd: Number(formMaterial.qtd),
      unidade: formMaterial.unidade,
      descprommaxfabricante:
        formMaterial.descprommaxfabricante === ""
          ? null
          : Number(formMaterial.descprommaxfabricante),
      obs: formMaterial.obs,
    };

    const endpoint = formMaterial.id
      ? "Campanhas/UpdCampanhaMaterial"
      : "Campanhas/InsCampanhaMaterial";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material gravado.", meta?.severity || "success");

    fecharDialogMaterial();
    await carregarMateriaisCampanha(form.id);
  };

  const pedirEliminarMaterial = (m) => {
    setMaterialParaEliminar(m);
    setOpenConfirmDelMaterial(true);
  };

  const fecharConfirmDelMaterial = () => {
    setOpenConfirmDelMaterial(false);
    setMaterialParaEliminar(null);
  };

  const confirmarEliminarMaterial = async () => {
    if (!materialParaEliminar?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaMaterial", { id: materialParaEliminar.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material eliminado.", meta?.severity || "success");

    fecharConfirmDelMaterial();
    await carregarMateriaisCampanha(form.id);
  };

  const abrirAlternativas = async (m) => {
    setMaterialAlternativasSelecionado(m);
    setFormAlternativa({
      id: null,
      idcampanhamaterial: m.id,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      descprommaxfabricante: "",
      fatorequivalencia: 1,
      obs: "",
    });
    setAlternativaInput("");
    setOpenDialogAlternativas(true);
    await carregarAlternativasMaterial(m.id);
  };

  const fecharDialogAlternativas = () => {
    setOpenDialogAlternativas(false);
    setMaterialAlternativasSelecionado(null);
    setAlternativaInput("");
    setFormAlternativa({
      id: null,
      idcampanhamaterial: null,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      descprommaxfabricante: "",
      fatorequivalencia: 1,
      obs: "",
    });
  };

  const abrirEditarAlternativa = (material, alternativa) => {
    setMaterialAlternativasSelecionado(material);

    setFormAlternativa({
      id: alternativa.id,
      idcampanhamaterial: alternativa.idcampanhamaterial,
      refmaterialalternativo: alternativa.refmaterialalternativo || "",
      qtd: alternativa.qtd ?? 0,
      unidade: alternativa.unidade || "",
      descprommaxfabricante: alternativa.descprommaxfabricante ?? "",
      fatorequivalencia: alternativa.fatorequivalencia ?? 1,
      obs: alternativa.obs || "",
    });

    setAlternativaInput(
      alternativa.materialalternativo
        ? `${alternativa.materialalternativo} (${alternativa.refmaterialalternativo})`
        : ""
    );

    setOpenDialogAlternativas(true);
  };

  const guardarAlternativa = async () => {
    if (!formAlternativa.idcampanhamaterial) {
      showAlert("Seleciona primeiro o material principal.", "warning");
      return;
    }

    if (!formAlternativa.refmaterialalternativo) {
      showAlert("Indica material alternativo.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formAlternativa.id,
      idcampanhamaterial: formAlternativa.idcampanhamaterial,
      refmaterialalternativo: formAlternativa.refmaterialalternativo,
      qtd: Number(formAlternativa.qtd),
      unidade: formAlternativa.unidade,
      descprommaxfabricante:
        formAlternativa.descprommaxfabricante === ""
          ? null
          : Number(formAlternativa.descprommaxfabricante),
      fatorequivalencia: Number(formAlternativa.fatorequivalencia || 1),
      obs: formAlternativa.obs,
    };

    const endpoint = formAlternativa.id
      ? "Campanhas/UpdCampanhaMaterialAlternativo"
      : "Campanhas/InsCampanhaMaterialAlternativo";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa gravada.", meta?.severity || "success");

    await carregarAlternativasMaterial(formAlternativa.idcampanhamaterial);
    fecharDialogAlternativas();
  };

  const apagarAlternativa = async (a) => {
    if (!a?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaMaterialAlternativo", { id: a.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa eliminada.", meta?.severity || "success");

    await carregarAlternativasMaterial(a.idcampanhamaterial);
  };

  const editarAlternativaGeral = (a) => {
    setFormAlternativaGeral({
      id: a.id,
      refmaterialalternativo: a.refmaterialalternativo || "",
      qtd: a.qtd || 1,
      unidade: a.unidade || "",
      descprommaxfabricante: a.descprommaxfabricante ?? "",
      fatorequivalencia: a.fatorequivalencia ?? 1,
      obs: a.obs || "",
    });

    setAlternativaGeralInput(
      a.materialalternativo ? `${a.materialalternativo} (${a.refmaterialalternativo})` : ""
    );
  };

  const apagarAlternativaGeral = async (a) => {
    if (!a?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaMaterialAlternativoGeral", { id: a.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa geral eliminada.", meta?.severity || "success");

    await carregarAlternativasGerais(form.id);
  };

  const guardarAlternativaGeral = async () => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formAlternativaGeral.refmaterialalternativo) {
      showAlert("Indica material alternativo.", "warning");
      return;
    }

    const refAlternativa = String(formAlternativaGeral.refmaterialalternativo || "");

    const jaExisteComoPrincipal = (materiaisCampanha || []).some(
      (m) => String(m.refmaterial || "") === refAlternativa
    );

    if (jaExisteComoPrincipal) {
      showAlert(
        "O material selecionado já está definido como material principal da campanha.",
        "warning"
      );
      return;
    }

    const jaExisteComoAlternativaGeral = (alternativasGerais || []).some(
      (a) =>
        String(a.refmaterialalternativo || "") === refAlternativa &&
        String(a.id) !== String(formAlternativaGeral.id || "")
    );

    if (jaExisteComoAlternativaGeral) {
      showAlert(
        "O material selecionado já existe como alternativa geral desta campanha.",
        "warning"
      );
      return;
    }

    setLoading(true);

    const body = {
      id: formAlternativaGeral.id,
      idcampanha: form.id,
      refmaterialalternativo: formAlternativaGeral.refmaterialalternativo,
      qtd: 0,
      unidade: formAlternativaGeral.unidade,
      descprommaxfabricante:
        formAlternativaGeral.descprommaxfabricante === ""
          ? null
          : Number(formAlternativaGeral.descprommaxfabricante),
      fatorequivalencia: Number(formAlternativaGeral.fatorequivalencia || 1),
      obs: formAlternativaGeral.obs,
    };

    const endpoint = formAlternativaGeral.id
      ? "Campanhas/UpdCampanhaMaterialAlternativoGeral"
      : "Campanhas/InsCampanhaMaterialAlternativoGeral";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa geral gravada.", meta?.severity || "success");

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      descprommaxfabricante: "",
      fatorequivalencia: 1,
      obs: "",
    });
    setAlternativaGeralInput("");
    setAlternativaGeralInput("");

    await carregarAlternativasGerais(form.id);
  };

  const abrirEditarOfertaCliente = (o) => {
    setFormOfertaCliente({
      id: o.id,
      refmaterialoferta: o.refmaterialoferta || "",
      qtd: o.qtd || 1,
      unidade: o.unidade || "",
      obs: o.obs || "",
      reembolsada: Number(o.reembolsada || 0),
    });

    setOfertaInput(o.materialoferta ? `${o.materialoferta} (${o.refmaterialoferta})` : "");

    setOpenDialogOfertaCliente(true);
  };

  const abrirNovaOfertaCliente = () => {
    setFormOfertaCliente({
      id: null,
      refmaterialoferta: "",
      qtd: 1,
      unidade: "",
      obs: "",
      reembolsada: 0,
    });
    setOfertaInput("");
    setOpenDialogOfertaCliente(true);
  };

  const fecharDialogOfertaCliente = () => {
    setOpenDialogOfertaCliente(false);
    setOfertaInput("");
    setFormOfertaCliente({
      id: null,
      refmaterialoferta: "",
      qtd: 1,
      unidade: "",
      obs: "",
      reembolsada: 0,
    });
  };

  const guardarOfertaCliente = async () => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formOfertaCliente.refmaterialoferta || Number(formOfertaCliente.qtd) <= 0) {
      showAlert("Indica material de oferta e quantidade.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formOfertaCliente.id,
      idcampanha: form.id,
      refmaterialoferta: formOfertaCliente.refmaterialoferta,
      qtd: Number(formOfertaCliente.qtd),
      unidade: formOfertaCliente.unidade,
      obs: formOfertaCliente.obs,
      reembolsada: Number(formOfertaCliente.reembolsada || 0),
    };

    const endpoint = formOfertaCliente.id
      ? "Campanhas/UpdCampanhaOferta"
      : "Campanhas/InsCampanhaOferta";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Oferta ao cliente gravada.", meta?.severity || "success");

    fecharDialogOfertaCliente();
    await carregarOfertasCliente(form.id);
  };

  const alterarReembolsadaOfertaCliente = async (oferta, checked) => {
    if (!oferta?.id) return;

    setLoading(true);

    const body = {
      id: oferta.id,
      idcampanha: form.id,
      refmaterialoferta: oferta.refmaterialoferta,
      qtd: Number(oferta.qtd),
      unidade: oferta.unidade || "",
      obs: oferta.obs || "",
      reembolsada: checked ? 1 : 0,
    };

    const [_, err, meta] = await handleApi(api.post("Campanhas/UpdCampanhaOferta", body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(
      meta?.message ||
        (checked ? "Oferta marcada como reembolsada." : "Oferta deixou de ser reembolsada."),
      meta?.severity || "success"
    );

    await carregarOfertasCliente(form.id);
    await carregarBeneficios(form.id);
  };

  const apagarOfertaCliente = async (o) => {
    if (!o?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(api.post("Campanhas/DelCampanhaOferta", { id: o.id }));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Oferta ao cliente eliminada.", meta?.severity || "success");

    await carregarOfertasCliente(form.id);
  };

  const abrirNovaAlternativaOfertaCliente = (o) => {
    setOfertaClienteAlternativasSelecionada(o);

    setFormOfertaClienteAlternativa({
      id: null,
      idcampanhaoferta: o.id,
      refmaterialalternativo: "",
      qtd: 0,
      unidade: "",
      obs: "",
    });

    setAlternativaInput("");
    setOpenDialogOfertaClienteAlternativas(true);
  };

  const abrirEditarAlternativaOfertaCliente = (oferta, alternativa) => {
    setOfertaClienteAlternativasSelecionada(oferta);

    setFormOfertaClienteAlternativa({
      id: alternativa.id,
      idcampanhaoferta: alternativa.idcampanhaoferta,
      refmaterialalternativo: alternativa.refmaterialalternativo || "",
      qtd: alternativa.qtd ?? 0,
      unidade: alternativa.unidade || "",
      obs: alternativa.obs || "",
    });

    setAlternativaInput(
      alternativa.materialalternativo
        ? `${alternativa.materialalternativo} (${alternativa.refmaterialalternativo})`
        : alternativa.refmaterialalternativo || ""
    );

    setOpenDialogOfertaClienteAlternativas(true);
  };

  const apagarAlternativaOfertaCliente = async (a) => {
    if (!a?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaOfertaAlternativo", { id: a.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa da oferta eliminada.", meta?.severity || "success");

    await carregarOfertasCliente(form.id);
  };

  const pedirEliminarBeneficio = async (b) => {
    if (!b?.id) return;

    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("Campanhas/VerificarDelCampanhaBeneficio", { id: b.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setBeneficioParaEliminar({
      ...b,
      temResultadosAssociados: payload?.temResultados === true,
      totalResultadosAssociados: payload?.totalResultados || 0,
    });

    setOpenConfirmDelBeneficio(true);
  };

  const fecharConfirmDelBeneficio = () => {
    setOpenConfirmDelBeneficio(false);
    setBeneficioParaEliminar(null);
  };

  const confirmarEliminarBeneficio = async () => {
    if (!beneficioParaEliminar?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaBeneficio", {
        id: beneficioParaEliminar.id,
        forcar: beneficioParaEliminar.temResultadosAssociados ? 1 : 0,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Benefício eliminado.", meta?.severity || "success");

    fecharConfirmDelBeneficio();
    await carregarBeneficios(form.id);
    await carregarResultados(form.id);
    await carregar();
  };

  const editarBeneficio = (b) => {
    setFormBeneficio({
      id: b.id,
      tipobeneficio: b.tipobeneficio || "VALOR_FIXO",
      basecalculo:
        b.tipobeneficio === "VALOR_FIXO" &&
        String(b.basecalculo || "") === "CONJUNTO" &&
        Number(b.aplicaporconjunto || 0) === 0
          ? "REEMBOLSO_UNICO"
          : b.basecalculo || "CONJUNTO",
      valor_eur: b.valor_eur ?? "",
      valor_por_unidade: b.valor_por_unidade ?? "",
      percentagem: b.percentagem ?? "",
      usar_iec: b.usar_iec === 1 ? 1 : 0,
      refmaterialgrupo_iec: b.refmaterialgrupo_iec || "",
      refmaterialoferta: b.refmaterialoferta || "",
      qtdoferta: b.qtdoferta ?? "",
      unidadeoferta: b.unidadeoferta || "",
      aplicaporconjunto:
        b.aplicaporconjunto === null ||
        b.aplicaporconjunto === undefined ||
        b.aplicaporconjunto === ""
          ? 1
          : Number(b.aplicaporconjunto),
      limitevalor_eur: b.limitevalor_eur ?? "",
      obs: b.obs || "",
    });

    setOfertaInput(
      b.materialoferta ? `${b.materialoferta} (${b.refmaterialoferta})` : b.refmaterialoferta || ""
    );
  };

  const guardarBeneficio = async () => {
    // console.log("Entrou no guardarBeneficio", formBeneficio, form);

    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formBeneficio.tipobeneficio || !formBeneficio.basecalculo) {
      showAlert("Indica tipo de benefício e base de cálculo.", "warning");
      return;
    }

    if (
      formBeneficio.tipobeneficio === "ESPECIE" &&
      ["VALOR", "VALOR_SEM_IEC"].includes(formBeneficio.basecalculo)
    ) {
      showAlert("A base de cálculo selecionada não é válida para benefício em espécie.", "warning");
      return;
    }

    if (formBeneficio.tipobeneficio === "ESPECIE") {
      if (
        !formBeneficio.refmaterialoferta ||
        Number(formBeneficio.qtdoferta) <= 0 ||
        !formBeneficio.unidadeoferta
      ) {
        showAlert("Indica material de oferta, quantidade e unidade.", "warning");
        return;
      }
    }

    setLoading(true);

    const baseCalculoBackend =
      formBeneficio.basecalculo === "REEMBOLSO_UNICO" ? "CONJUNTO" : formBeneficio.basecalculo;

    const body = {
      ...formBeneficio,
      idcampanha: form.id,
      basecalculo: baseCalculoBackend,
      valor_eur: formBeneficio.valor_eur === "" ? null : Number(formBeneficio.valor_eur),
      valor_por_unidade:
        formBeneficio.valor_por_unidade === "" ? null : Number(formBeneficio.valor_por_unidade),
      percentagem: formBeneficio.percentagem === "" ? null : Number(formBeneficio.percentagem),
      qtdoferta: formBeneficio.qtdoferta === "" ? null : Number(formBeneficio.qtdoferta),
      limitevalor_eur:
        formBeneficio.limitevalor_eur === "" ? null : Number(formBeneficio.limitevalor_eur),
      aplicaporconjunto:
        formBeneficio.aplicaporconjunto === "" ||
        formBeneficio.aplicaporconjunto === null ||
        formBeneficio.aplicaporconjunto === undefined
          ? 1
          : Number(formBeneficio.aplicaporconjunto),
    };

    const endpoint = formBeneficio.id
      ? "Campanhas/UpdCampanhaBeneficio"
      : "Campanhas/InsCampanhaBeneficio";

    // console.log("Benefício a gravar:", endpoint, body);

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Benefício gravado.", meta?.severity || "success");

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setOfertaInput("");

    await carregarBeneficios(form.id);
  };

  const adicionarFiltroCampanha = async (campo, tipo, valor, obs = "") => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!campo || !tipo || !valor) {
      showAlert("Filtro inválido.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhaFiltro", {
        idcampanha: form.id,
        campo,
        tipo,
        valor,
        obs,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Filtro inserido.", meta?.severity || "success");

    await carregarFiltrosCampanha(form.id);
  };

  const removerFiltroCampanha = async (filtro) => {
    if (!filtro?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaFiltro", { id: filtro.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Filtro eliminado.", meta?.severity || "success");

    await carregarFiltrosCampanha(form.id);
  };

  const atualizarClientesIncluidosCampanha = async (refsclientes) => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/UpdCampanhasClientesIncluidosLote", {
        idcampanha: form.id,
        refsclientes,
        atualizado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Clientes incluídos atualizados.", meta?.severity || "success");

    await carregarClientesAcordosCampanha(form.id, form.reffabricante);
  };

  const clientesAcordosFiltrados = useMemo(() => {
    const pesquisa = normalizeSearchText(filtroClientesAcordos);
    const termos = pesquisa.split(/\s+/).filter(Boolean);

    if (termos.length === 0) return clientesAcordosCampanha;

    return clientesAcordosCampanha.filter((c) => {
      const texto = normalizeSearchText(
        `${c?.cliente ?? ""} ${c?.refcliente ?? ""} ${c?.nif ?? ""} ${c?.acordo ?? ""} ${
          c?.obs ?? ""
        }`
      );

      return termos.every((termo) => texto.includes(termo));
    });
  }, [clientesAcordosCampanha, filtroClientesAcordos]);

  const todosClientesAcordosFiltradosIncluidos = useMemo(() => {
    return (
      clientesAcordosFiltrados.length > 0 &&
      clientesAcordosFiltrados.every((c) => Number(c.incluido || 0) === 1)
    );
  }, [clientesAcordosFiltrados]);

  const toggleClienteAcordoIncluido = async (refcliente) => {
    if (!refcliente) return;

    const atuais = clientesAcordosCampanha
      .filter((x) => Number(x.incluido || 0) === 1)
      .map((x) => String(x.refcliente || ""));

    const novos = atuais.includes(String(refcliente))
      ? atuais.filter((x) => x !== String(refcliente))
      : [...atuais, String(refcliente)];

    await atualizarClientesIncluidosCampanha(novos);
  };

  const atualizarFiltrosCampanhaLote = async (campos, filtros) => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    setLoading(true);
    setLoadingFiltrosCampanha(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/UpdCampanhasFiltrosLote", {
        idcampanha: form.id,
        campos,
        filtros,
      })
    );

    if (err) {
      setLoading(false);
      setLoadingFiltrosCampanha(false);
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Filtros atualizados.", meta?.severity || "success");

    await carregarFiltrosCampanha(form.id);

    setLoading(false);
    setLoadingFiltrosCampanha(false);
  };

  const abrirRecusarFatura = (r) => {
    setFaturaParaRecusar(r);
    setMotivoRecusaFatura(r?.motivorecusa || "");
    setOpenRecusarFatura(true);
  };

  const fecharRecusarFatura = () => {
    setOpenRecusarFatura(false);
    setFaturaParaRecusar(null);
    setMotivoRecusaFatura("");
  };

  const gravarRecusaFatura = async () => {
    if (!faturaParaRecusar?.id) {
      showAlert("Resultado inválido.", "error");
      return;
    }

    if (!motivoRecusaFatura.trim()) {
      showAlert("Indique o motivo da recusa.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/RecusarCampanhaFatura", {
        idcampanhafatura: faturaParaRecusar.id,
        motivorecusa: motivoRecusaFatura.trim(),
        criado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Fatura recusada/excluída.", meta?.severity || "success");

    fecharRecusarFatura();

    if (campanhaResultados?.id) {
      await carregarResultados(campanhaResultados.id);
    } else if (form.id) {
      await carregarResultados(form.id);
    }
  };

  const reintegrarFatura = async (r) => {
    if (!r?.id) {
      showAlert("Resultado inválido.", "error");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/ReintegrarCampanhaFatura", {
        idcampanhafatura: r.id,
        reintegrado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Fatura reintegrada.", meta?.severity || "success");

    if (campanhaResultados?.id) {
      await carregarResultados(campanhaResultados.id);
    } else if (form.id) {
      await carregarResultados(form.id);
    }
  };

  const abrirResultado = async (r) => {
    setResultadoSelecionado(r);
    setOpenResultado(true);

    const [linhasPayload, linhasErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasLinhas", { idcampanhafatura: r.id })
    );
    setResultadoLinhas(linhasErr ? [] : Array.isArray(linhasPayload) ? linhasPayload : []);
    if (linhasErr) showAlert(linhasErr, "error");

    const [beneficiosPayload, beneficiosErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasBeneficios", { idcampanhafatura: r.id })
    );
    setResultadoBeneficios(
      beneficiosErr ? [] : Array.isArray(beneficiosPayload) ? beneficiosPayload : []
    );
    if (beneficiosErr) showAlert(beneficiosErr, "error");

    const [recebimentosPayload, recebimentosErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasRecebimentos", { idcampanhafatura: r.id })
    );
    setResultadoRecebimentos(
      recebimentosErr ? [] : Array.isArray(recebimentosPayload) ? recebimentosPayload : []
    );
    if (recebimentosErr) showAlert(recebimentosErr, "error");
  };

  const abrirRecebimentos = async (idcampanha = form.id) => {
    if (!idcampanha) {
      showAlert("Seleciona primeiro uma campanha.", "warning");
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturas", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    let histPayload = [];
    let histErr = null;

    try {
      const resHist = await api.post("Campanhas/SelCampanhasFaturasRecebimentos", { idcampanha });

      console.log("RAW histórico recebimentos:", resHist.data);

      histPayload = resHist.data?.data || [];
    } catch (e) {
      histErr = e?.message || "Erro ao carregar histórico de recebimentos.";
    }

    setHistoricoRecebimentosCampanha(Array.isArray(histPayload) ? histPayload : []);

    if (histErr) showAlert(histErr, "error");

    setHistoricoRecebimentosCampanha(histErr ? [] : Array.isArray(histPayload) ? histPayload : []);
    if (histErr) showAlert(histErr, "error");

    const linhas = (Array.isArray(payload) ? payload : [])
      .filter((r) => ["Detetado", "Solicitado", "Parcial"].includes(r.estado))
      .map((r) => {
        const valorAReceber = Number(r.valor_a_receber || 0);
        const valorRecebido = Number(r.valor_total_recebido || 0);
        const valorEmFalta = Math.max(0, valorAReceber - valorRecebido);

        return {
          ...r,
          selecionado: false,
          novo_recebimento: 0,
          valor_em_falta: valorEmFalta,
        };
      });

    setRecebimentosLinhas(linhas);
    setRecebimentosForm({
      datarecebimento: new Date().toISOString().substring(0, 10),
      docref: "",
      obs: "",
    });
    setOpenRecebimentos(true);
  };

  const apagarRecebimentoCampanha = async (recebimento) => {
    if (!recebimento?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaFaturaRecebimento", { id: recebimento.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Recebimento apagado.", meta?.severity || "success");

    const idCampanhaAtual =
      campanhaResultados?.id ||
      recebimento?.idcampanha ||
      recebimentosLinhas?.[0]?.idcampanha ||
      form.id;

    if (idCampanhaAtual) {
      await abrirRecebimentos(idCampanhaAtual);
      await carregarResultados(idCampanhaAtual);
    }

    await carregar();
  };

  const gravarRecebimentos = async () => {
    const itens = recebimentosLinhas
      .filter((x) => x.selecionado && Number(x.novo_recebimento || 0) !== 0)
      .map((x) => ({
        idcampanhafatura: x.id,
        valor_recebido: Number(x.novo_recebimento || 0),
      }));

    if (itens.length === 0) {
      showAlert("Não existem recebimentos selecionados para gravar.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhasFaturasRecebimentosLote", {
        itens,
        datarecebimento: recebimentosForm.datarecebimento,
        docref: recebimentosForm.docref,
        obs: recebimentosForm.obs,
        criado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Recebimentos gravados.", meta?.severity || "success");

    setOpenRecebimentos(false);

    const idCampanhaAtual =
      campanhaResultados?.id || recebimentosLinhas?.[0]?.idcampanha || form.id;

    if (idCampanhaAtual) {
      await carregarResultados(idCampanhaAtual);
    }

    await carregar();
  };

  const exportarAlertasCampanhas = async () => {
    try {
      setLoading(true);

      const res = await api({
        url: "Campanhas/ExportarAlertasCampanhas",
        method: "post",
        data: {},
        responseType: "arraybuffer",
      });

      const contentType = res.headers["content-type"] || "";

      if (!contentType.includes("spreadsheetml")) {
        const texto = new TextDecoder().decode(res.data);
        console.log("CONTENT-TYPE:", contentType);
        console.log("RESPOSTA API:", texto);

        showAlert("A API não devolveu Excel. Ver consola (F12).", "error");
        return;
      }

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `Alertas_Campanhas_${new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/[-:T]/g, "")
        .replace(/^(\d{6})(\d{4})$/, "$1_$2")}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel de alertas gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar o Excel de alertas.", "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "acoes",
        disableFilters: true,
        disableSortBy: true,
        filterable: false,
        sortable: false,
        hideable: false,
        resizable: false,
        width: 240,
        minWidth: 240,
        maxWidth: 240,
        Cell: ({ row }) => {
          const c = row.original;
          return (
            <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
              <IconButton
                size="small"
                color="primary"
                disabled={!temPermissao("Menu Comercial", "u")}
                onClick={() => handleOpenEditar(c)}
                title="Editar campanha"
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={!temPermissao("Menu Comercial", "r")}
                onClick={() => abrirInfoCampanha(c)}
                title="Informação da campanha"
              >
                <InfoIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={!temPermissao("Menu Comercial", "r")}
                onClick={() => abrirResultadosCampanha(c)}
                title="Ver resultados detetados"
              >
                <ListIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="warning"
                disabled={
                  !temPermissao("Menu Comercial", "r") ||
                  (Number(c.total_sem_flag_campanha || 0) === 0 &&
                    Number(c.total_descprom_acima_maximo || 0) === 0 &&
                    Number(c.total_diferenca_flag_conjuntos || 0) === 0)
                }
                onClick={() => abrirResultadosCampanhaComAlertas(c)}
                title={
                  Number(c.total_sem_flag_campanha || 0) === 0 &&
                  Number(c.total_descprom_acima_maximo || 0) === 0 &&
                  Number(c.total_diferenca_flag_conjuntos || 0) === 0
                    ? "Sem alertas"
                    : "Ver apenas resultados com alertas"
                }
              >
                <ListIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={
                  !temPermissao("Menu Comercial", "u") ||
                  !c.datafinal ||
                  new Date(String(c.datafinal).substring(0, 10)) >=
                    new Date(new Date().toISOString().substring(0, 10))
                }
                onClick={() => abrirDialogEmail(c)}
                title={
                  c.datafinal &&
                  new Date(String(c.datafinal).substring(0, 10)) <
                    new Date(new Date().toISOString().substring(0, 10))
                    ? "Enviar pedido de reembolso ao fabricante"
                    : "Só é possível enviar após a data final da campanha"
                }
              >
                <EmailIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="error"
                disabled={!temPermissao("Menu Comercial", "d")}
                onClick={() => pedirEliminarCampanha(c)}
                title="Apagar campanha"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
      { Header: "Campanha", accessor: "nome" },
      { Header: "Código", accessor: "codigo_campanha" },
      { Header: "Fabricante", accessor: "fabricante" },
      {
        Header: "Valor apurado",
        accessor: "valor_total_apurado",
        align: "right",
        Cell: ({ value }) => Number(value || 0).toFixed(2),
      },
      {
        Header: "Valor recebido",
        accessor: "valor_total_recebido",
        align: "right",
        Cell: ({ value }) => Number(value || 0).toFixed(2),
      },
      {
        Header: "Data inicial",
        accessor: "datainicial",
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Data final",
        accessor: "datafinal",
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      { Header: "Período", accessor: "estado_periodo" },
      { Header: "Estado", accessor: "estado" },
      {
        Header: "Email",
        accessor: "enviaremail",
        Cell: ({ value }) => (value === 1 ? "Sim" : "Não"),
      },
      { Header: "Contacto", accessor: "contacto_nome" },
    ],
    [temPermissao]
  );

  const totalValorApuradoVisivel = linhasVisiveis.reduce(
    (acc, row) => acc + Number(row?.valor_total_apurado || 0),
    0
  );

  const totalValorRecebidoVisivel = linhasVisiveis.reduce(
    (acc, row) => acc + Number(row?.valor_total_recebido || 0),
    0
  );

  const handleFiltroClienteAccordion = (panel) => (_event, isExpanded) => {
    setExpandedFiltroCliente(isExpanded ? panel : null);
  };

  const gruposClienteDefault = ["Z001", "Z002", "Z004", "Z009", "Z011"];

  const filtroGrupoClienteSelecionado = (ref) => {
    const filtrosGrupo = filtrosPorCampo("refentidadegrupo");

    if (filtrosGrupo.length === 0) {
      return gruposClienteDefault.includes(String(ref || ""));
    }

    return filtroExiste("refentidadegrupo", "INCLUIR", ref);
  };

  const filtroExiste = (campo, tipo, valor) =>
    filtrosCampanha.some(
      (f) =>
        String(f.campo || "") === String(campo) &&
        String(f.tipo || "") === String(tipo) &&
        String(f.valor || "") === String(valor)
    );

  const filtrosPorCampo = (campo) =>
    filtrosCampanha.filter((f) => String(f.campo || "") === String(campo));

  const toggleFiltroCampanha = async (campo, tipo, valor, obs = "") => {
    const camposSegmentos = ["segmentopotencial", "segmenton1", "segmenton2", "segmenton3"];
    const isSegmento = camposSegmentos.includes(String(campo || ""));

    if (!isSegmento) {
      const existente = filtrosCampanha.find(
        (f) =>
          String(f.campo || "") === String(campo) &&
          String(f.tipo || "") === String(tipo) &&
          String(f.valor || "") === String(valor)
      );

      if (existente) {
        await removerFiltroCampanha(existente);
        return;
      }

      await adicionarFiltroCampanha(campo, tipo, valor, obs);
      return;
    }

    const existentesCampo = filtrosCampanha.filter((f) => String(f.campo || "") === String(campo));

    const jaExiste = existentesCampo.some(
      (f) => String(f.tipo || "") === String(tipo) && String(f.valor || "") === String(valor)
    );

    let novosFiltros = [];

    if (jaExiste) {
      novosFiltros = existentesCampo
        .filter(
          (f) => String(f.tipo || "") === "INCLUIR" && String(f.valor || "") !== String(valor)
        )
        .map((f) => ({
          campo: f.campo,
          tipo: f.tipo,
          valor: f.valor,
          obs: f.obs || f.valor,
        }));

      if (novosFiltros.length === 0) {
        novosFiltros = [
          {
            campo,
            tipo: "NENHUM",
            valor: "1",
            obs: "Nenhum selecionado",
          },
        ];
      }
    } else {
      novosFiltros = existentesCampo
        .filter((f) => String(f.tipo || "") === "INCLUIR")
        .map((f) => ({
          campo: f.campo,
          tipo: f.tipo,
          valor: f.valor,
          obs: f.obs || f.valor,
        }));

      novosFiltros.push({
        campo,
        tipo,
        valor,
        obs,
      });
    }

    await atualizarFiltrosCampanhaLote([campo], novosFiltros);
  };

  const tipoBeneficio = formBeneficio.tipobeneficio;

  const basesCalculoBeneficio =
    tipoBeneficio === "ESPECIE"
      ? [
          { value: "CONJUNTO", label: "Conjunto" },
          { value: "LINHA", label: "Linha" },
          { value: "QTD", label: "Quantidade" },
          { value: "VOLUME", label: "Volume" },
        ]
      : [
          { value: "CONJUNTO", label: "Conjunto" },
          { value: "LINHA", label: "Linha" },
          { value: "VALOR", label: "Valor" },
          { value: "VALOR_SEM_IEC", label: "Valor sem IEC" },
          { value: "QTD", label: "Quantidade" },
          { value: "VOLUME", label: "Volume" },
        ];

  const mostrarValorEur = tipoBeneficio === "VALOR_FIXO";
  const mostrarValorUnidade = tipoBeneficio === "VALOR_POR_UNIDADE";
  const mostrarPercentagem = tipoBeneficio === "PERCENTAGEM";
  const mostrarOferta = tipoBeneficio === "ESPECIE";

  const gravarResolucaoAlerta = async (alerta, obsresolucao) => {
    if (!alerta?.id) {
      showAlert("Alerta inválido.", "error");
      return;
    }

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/UpdCampanhaFaturaAlertaResolucao", {
        id: alerta.id,
        obsresolucao,
        obsresolucao_por: userData?.id || null,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Resolução atualizada.", meta?.severity || "success");

    if (campanhaResultados?.id) {
      await carregarAlertasCampanha(campanhaResultados.id);
    }
  };

  const abrirResultadosCampanha = async (
    campanha,
    apenasAlertas = false,
    periodoExterno = null
  ) => {
    if (!campanha?.id) return;

    const periodoInicial =
      periodoExterno?.datainicial && periodoExterno?.datafinal
        ? {
            datainicial: periodoExterno.datainicial,
            datafinal: periodoExterno.datafinal,
          }
        : {
            datainicial: campanha.datainicial ? String(campanha.datainicial).substring(0, 10) : "",
            datafinal: campanha.datafinal ? String(campanha.datafinal).substring(0, 10) : "",
          };

    setSoComAlertas(apenasAlertas);
    setCampanhaResultados(campanha);
    setPeriodoResultadosCampanha(periodoInicial);
    setResultados([]);
    setOpenResultadosCampanha(true);

    await carregarResultados(campanha.id, periodoInicial);
    await carregarAlertasCampanha(campanha.id);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const idcampanha = Number(params.get("ccCampanha") || 0);
    const datainicial = params.get("datainicial") || "";
    const datafinal = params.get("datafinal") || "";

    if (!idcampanha) return;

    let cancelado = false;

    const abrirCampanhaRecebida = async () => {
      setLoading(true);

      try {
        const [payload, err] = await handleApi(
          api.post("Campanhas/SelCampanha", {
            id: idcampanha,
          })
        );

        if (cancelado) return;

        if (err) {
          showAlert(err, "error");
          return;
        }

        if (!payload?.id) {
          showAlert("Campanha não encontrada.", "warning");
          return;
        }

        await abrirResultadosCampanha(payload, false, {
          datainicial,
          datafinal,
        });

        window.history.replaceState({}, document.title, window.location.pathname);
      } finally {
        if (!cancelado) {
          setLoading(false);
        }
      }
    };

    abrirCampanhaRecebida();

    return () => {
      cancelado = true;
    };
  }, []);

  const abrirResultadosCampanhaComAlertas = async (campanha) => {
    await abrirResultadosCampanha(campanha, true);
  };

  const abrirInfoCampanha = async (campanha) => {
    if (!campanha?.id) return;

    setCampanhaInfo(null);
    setOpenInfoCampanha(true);
    setLoadingInfoCampanha(true);

    const [payload, err] = await handleApi(api.post("Campanhas/SelCampanha", { id: campanha.id }));

    if (err) {
      setLoadingInfoCampanha(false);
      showAlert(err, "error");
      return;
    }

    await carregarContactos(payload.reffabricante);
    await carregarMateriaisCampanha(payload.id);
    await carregarAlternativasGerais(payload.id);
    await carregarOfertasCliente(payload.id);
    await carregarBeneficios(payload.id);
    await carregarFiltrosCampanha(payload.id);
    await carregarClientesAcordosCampanha(payload.id, payload.reffabricante);

    setCampanhaInfo(payload);
    setLoadingInfoCampanha(false);
  };

  const abrirDialogEmail = async (campanha) => {
    if (!campanha?.id) return;

    setCampanhaEmail(campanha);
    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelEmailReembolsoCampanha", {
        idcampanha: campanha.id,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setEmailForm({
      to: payload?.to || "",
      cc: payload?.cc || "",
      bcc: payload?.bcc || "",
      assunto: payload?.assunto || `Pedido de reembolso - ${campanha.nome}`,
      mensagem: payload?.mensagem || "",
    });

    setOpenDialogEmail(true);
  };

  const enviarEmailReembolso = async () => {
    if (!campanhaEmail?.id) {
      showAlert("Campanha inválida.", "error");
      return;
    }

    if (!emailForm.to) {
      showAlert("Indica pelo menos um destinatário.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/EnviarReembolsoCampanha", {
        idcampanha: campanhaEmail.id,
        to: emailForm.to,
        cc: emailForm.cc,
        bcc: emailForm.bcc,
        assunto: emailForm.assunto,
        mensagem: emailForm.mensagem,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Email enviado com sucesso.", meta?.severity || "success");

    setOpenDialogEmail(false);
    await carregarResultados(campanhaEmail.id);
    await carregar();
  };

  const descarregarAnexoReembolso = async () => {
    if (!campanhaEmail?.id) {
      showAlert("Campanha inválida.", "error");
      return;
    }

    try {
      setLoadingAnexoEmail(true);

      const res = await api.get("Campanhas/GerarExcelReembolsoCampanha", {
        params: { idcampanha: campanhaEmail.id },
        responseType: "blob",
      });

      const contentDisposition = res.headers["content-disposition"] || "";
      let fileName = "Reembolso_Campanha.xlsx";

      const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
      if (match?.[1]) {
        fileName = decodeURIComponent(match[1]);
      }

      const blob = new Blob([res.data], {
        type:
          res.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showAlert("Erro ao gerar o anexo.", "error");
    } finally {
      setLoadingAnexoEmail(false);
    }
  };

  const consultarBeneficiosFatura = async () => {
    if (!faturaConsulta.trim()) {
      showAlert("Indica o número da fatura.", "warning");
      return;
    }

    setLoadingConsultaFatura(true);

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasBeneficiosPorFatura", {
        faturaorigem: faturaConsulta.trim(),
      })
    );

    setLoadingConsultaFatura(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setResultadosConsultaFatura(Array.isArray(payload) ? payload : []);
  };

  const limparVendedor = (v) => {
    if (!v) return "";

    return v
      .replace(/\s*(TEL\.?|TL)\s*:\s*.*$/i, "") // remove TEL:, TEL.:, TL:
      .trim();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox pt={1}>
        <Card>
          <MDBox p={{ xs: 1.5, md: 3 }}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems={{ xs: "stretch", md: "center" }}
              flexDirection={{ xs: "column", md: "row" }}
              gap={1.5}
              mb={2}
            >
              <MDTypography variant="h6">Campanhas comerciais</MDTypography>

              <MDBox
                display="flex"
                alignItems={{ xs: "stretch", md: "center" }}
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                flexDirection={{ xs: "column", sm: "row" }}
                flexWrap="wrap"
                gap={1}
                sx={{
                  "& .MuiFormControlLabel-root": {
                    marginLeft: 0,
                  },
                  "& .MuiButton-root": {
                    width: { xs: "100%", sm: "auto" },
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <MDButton
                  color="success"
                  disabled={!temPermissao("Menu Comercial", "w")}
                  onClick={handleOpenNovo}
                >
                  Nova Campanha
                </MDButton>

                <MDButton
                  color="info"
                  disabled={!temPermissao("Menu Comercial", "u")}
                  onClick={abrirProcessarFabricante}
                >
                  Processar por fabricante
                </MDButton>

                <MDButton
                  color="secondary"
                  disabled={!temPermissao("Menu Comercial", "r")}
                  onClick={() => {
                    setFaturaConsulta("");
                    setResultadosConsultaFatura([]);
                    setOpenConsultaFatura(true);
                  }}
                >
                  Consultar fatura
                </MDButton>

                <MDBox display="flex" gap={1} flexWrap="wrap">
                  <MDButton
                    color="warning"
                    startIcon={<TableViewIcon />}
                    disabled={!temPermissao("Menu Comercial", "r")}
                    onClick={exportarAlertasCampanhas}
                  >
                    EXPORTAR ALERTAS
                  </MDButton>

                  <MDButton
                    color="warning"
                    startIcon={<EditNoteIcon />}
                    disabled={!temPermissao("Menu Comercial", "r")}
                    onClick={abrirEditarAlertas}
                  >
                    EDITAR ALERTAS
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>

            <ProjectTable
              tableKey="campanhas"
              version="v1"
              columns={columns}
              data={data}
              loading={loading}
              emptyMessage="Sem campanhas para apresentar."
              minWidth={1500}
              maxHeight="68vh"
              onVisibleRowsChange={setLinhasVisiveis}
              toolbarLeft={
                <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                  <MDBox
                    sx={{
                      backgroundColor: "#f2f2f2",
                      borderRadius: 1,
                      px: 1,
                      py: 0.5,
                    }}
                  >
                    <MDTypography variant="caption" fontWeight="bold">
                      Valor apurado: {totalValorApuradoVisivel.toFixed(2)}
                    </MDTypography>
                  </MDBox>

                  <MDBox
                    sx={{
                      backgroundColor: "#f2f2f2",
                      borderRadius: 1,
                      px: 1,
                      py: 0.5,
                    }}
                  >
                    <MDTypography variant="caption" fontWeight="bold">
                      Valor recebido: {totalValorRecebidoVisivel.toFixed(2)}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              }
              showKeepFilters
            />
          </MDBox>
        </Card>
      </MDBox>

      <Dialog
        PaperComponent={PaperComponent}
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            width: { xs: "calc(100% - 24px)", md: "1100px" },
            maxWidth: "100%",
            m: { xs: 1.5, md: 3 },
          },
        }}
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          {editando ? "Editar campanha" : "Nova campanha"}
        </DialogTitle>

        <DialogContent
          sx={{
            px: { xs: 1.5, md: 3 },
            maxWidth: "100%",
            overflowX: "hidden",
          }}
        >
          {loading && openDialog && (
            <MDBox py={3} display="flex" alignItems="center" justifyContent="center">
              <CircularProgress size={32} />
            </MDBox>
          )}

          <MDBox
            display="grid"
            gap={1.5}
            mt={1}
            sx={{
              opacity: loading && openDialog ? 0.35 : 1,
              maxWidth: "100%",
              overflowX: "hidden",
            }}
          >
            {!editando && (
              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>
                  Copiar de campanha existente
                </div>

                <Autocomplete
                  size="small"
                  options={data}
                  filterOptions={campanhaCopiaFilter}
                  getOptionLabel={(option) =>
                    option?.nome
                      ? `${option.nome} (${option.fabricante || option.reffabricante || ""})`
                      : ""
                  }
                  value={campanhaOrigemCopia}
                  onChange={(_, value) => {
                    setCampanhaOrigemCopia(value);

                    if (value) {
                      setForm((p) => ({
                        ...p,
                        nome: value.nome || "",
                        codigo_campanha: "",
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Selecionar campanha para copiar..." />
                  )}
                />
              </div>
            )}

            <MDInput
              label="Nome"
              value={form.nome}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  nome: e.target.value.toUpperCase(),
                }))
              }
              fullWidth
            />

            <MDInput
              label="Código da campanha"
              value={form.codigo_campanha}
              onChange={(e) => setForm((p) => ({ ...p, codigo_campanha: e.target.value }))}
              fullWidth
            />

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>
              <Autocomplete
                size="small"
                options={fabricantes}
                filterOptions={(x) => x}
                inputValue={fabricanteInput}
                getOptionLabel={(option) => (option?.nome ? `${option.nome} (${option.ref})` : "")}
                value={fabricantes.find((f) => f.ref === form.reffabricante) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setFabricanteInput(value);
                    setForm((p) => ({
                      ...p,
                      reffabricante: "",
                      idfabricantecontacto: "",
                    }));
                    setContactos([]);
                    carregarFabricantes(value);
                  }

                  if (reason === "clear") {
                    setFabricanteInput("");
                  }
                }}
                onChange={async (_, value) => {
                  const ref = value?.ref || "";

                  setForm((p) => ({
                    ...p,
                    reffabricante: ref,
                    idfabricantecontacto: "",
                  }));

                  setFabricanteInput(value?.nome ? `${value.nome} (${value.ref})` : "");
                  await carregarContactos(ref);
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>
                Contacto do fabricante
              </div>
              <Autocomplete
                size="small"
                options={contactos}
                filterOptions={contactoFabricanteFilter}
                getOptionLabel={(option) =>
                  option?.nome ? `${option.nome}${option.email ? ` (${option.email})` : ""}` : ""
                }
                value={
                  contactos.find((c) => String(c.id) === String(form.idfabricantecontacto)) || null
                }
                onChange={(_, value) =>
                  setForm((p) => ({ ...p, idfabricantecontacto: value?.id || "" }))
                }
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
              <MDInput
                label="Data inicial"
                type="date"
                value={form.datainicial}
                onChange={(e) => setForm((p) => ({ ...p, datainicial: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              <MDInput
                label="Data final"
                type="date"
                value={form.datafinal}
                onChange={(e) => setForm((p) => ({ ...p, datafinal: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Estado</div>
              <select
                value={form.estado === "Inativa" ? "Pendente" : form.estado || "Pendente"}
                onChange={(e) => setForm((p) => ({ ...p, estado: e.target.value }))}
                disabled={form.estado === "Inativa"}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: 8,
                  border: "1px solid #d2d6da",
                  fontSize: 14,
                  color: "#344767",
                }}
              >
                <option value="Pendente">Pendente</option>
                <option value="Recebida">Recebida</option>
              </select>
            </div>

            <FormControlLabel
              control={
                <Checkbox
                  checked={form.estado === "Inativa"}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      estado: e.target.checked ? "Inativa" : "Pendente",
                    }))
                  }
                  size="small"
                  disabled={form.estado === "Recebida"}
                  sx={{ ml: 0.5 }}
                />
              }
              label="Inativo"
            />

            <div>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  color: "#7b809a",
                  marginBottom: 2,
                }}
              >
                Acumulação extra
              </div>
              <select
                value={form.extra_campanha || 0}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    extra_campanha: Number(e.target.value),
                  }))
                }
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: 8,
                  border: "1px solid #d2d6da",
                  fontSize: 14,
                  color: "#344767",
                }}
              >
                <option value={0}>Normal</option>
                {/* <option value={1}>Extra - uma única fatura</option>
                <option value={2}>Extra - sempre enquanto em vigor</option> */}
                <option value={3}>Extra - até ao limite da quantidade acordada (uma vez)</option>
                <option value={4}>Extra - até ao limite da quantidade acordada (contínuo)</option>
              </select>
            </div>

            <FormControlLabel
              control={
                <Checkbox
                  checked={form.aceitaclientesparticulares === 1}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      aceitaclientesparticulares: e.target.checked ? 1 : 0,
                    }))
                  }
                  size="small"
                  sx={{ ml: 0.5 }}
                />
              }
              label="Aceita clientes particulares"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={form.enviaremail === 1}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, enviaremail: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                  sx={{ ml: 0.5 }}
                />
              }
              label="Enviar email ao criar campanha"
            />

            <MDInput
              label="Observações"
              value={form.obs}
              onChange={(e) => setForm((p) => ({ ...p, obs: e.target.value }))}
              fullWidth
              multiline
              rows={3}
            />

            {editando && (
              <MDBox display="grid" gap={2}>
                <CampanhaFiltrosClientes
                  expandedFiltroCliente={expandedFiltroCliente}
                  handleFiltroClienteAccordion={handleFiltroClienteAccordion}
                  todosClientesAcordosFiltradosIncluidos={todosClientesAcordosFiltradosIncluidos}
                  clientesAcordosFiltrados={clientesAcordosFiltrados}
                  clientesAcordosCampanha={clientesAcordosCampanha}
                  atualizarClientesIncluidosCampanha={atualizarClientesIncluidosCampanha}
                  filtroClientesAcordos={filtroClientesAcordos}
                  setFiltroClientesAcordos={setFiltroClientesAcordos}
                  toggleClienteAcordoIncluido={toggleClienteAcordoIncluido}
                  gruposClientes={gruposClientes}
                  filtroGrupoClienteSelecionado={filtroGrupoClienteSelecionado}
                  toggleFiltroCampanha={toggleFiltroCampanha}
                  loadingFiltrosCampanha={loadingFiltrosCampanha}
                  filtrosCampanha={filtrosCampanha}
                  atualizarFiltrosCampanhaLote={atualizarFiltrosCampanhaLote}
                  segmentosClientes={segmentosClientes}
                  filtroExiste={filtroExiste}
                  clienteInput={clienteInput}
                  setClienteInput={setClienteInput}
                  carregarClientesCombo={carregarClientesCombo}
                  clientesCombo={clientesCombo}
                  adicionarFiltroCampanha={adicionarFiltroCampanha}
                  filtrosPorCampo={filtrosPorCampo}
                  removerFiltroCampanha={removerFiltroCampanha}
                />

                <MDBox
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: { xs: 1.5, md: 2 },
                  }}
                >
                  <MDTypography variant="h6" mb={1.5}>
                    Regras dos materiais
                  </MDTypography>

                  <MDInput
                    label="Mínimo de referências distintas por conjunto (0 = sem regra)"
                    type="number"
                    value={form.min_refs_distintas}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        min_refs_distintas: Math.max(0, Math.trunc(Number(e.target.value || 0))),
                      }))
                    }
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                    helperText="Deixar 0 quando não existe exigência de referências distintas. Ex.: 3 obriga cada conjunto a utilizar pelo menos 3 referências diferentes."
                    fullWidth
                  />
                </MDBox>

                <CampanhaMateriaisPrincipais
                  materiaisCampanha={materiaisCampanha}
                  alternativasPorMaterial={alternativasPorMaterial}
                  abrirNovoMaterial={abrirNovoMaterial}
                  abrirEditarMaterial={abrirEditarMaterial}
                  pedirEliminarMaterial={pedirEliminarMaterial}
                  abrirAlternativas={abrirAlternativas}
                  abrirEditarAlternativa={abrirEditarAlternativa}
                  apagarAlternativa={apagarAlternativa}
                />

                <CampanhaAlternativasGerais
                  materiaisCombo={materiaisCombo}
                  materiaisCampanha={materiaisCampanha}
                  materialLabel={materialLabel}
                  alternativaGeralInput={alternativaGeralInput}
                  setAlternativaGeralInput={setAlternativaGeralInput}
                  formAlternativaGeral={formAlternativaGeral}
                  setFormAlternativaGeral={setFormAlternativaGeral}
                  carregarMateriaisCombo={carregarMateriaisCombo}
                  guardarAlternativaGeral={guardarAlternativaGeral}
                  alternativasGerais={alternativasGerais}
                  editarAlternativaGeral={editarAlternativaGeral}
                  apagarAlternativaGeral={apagarAlternativaGeral}
                  form={form}
                  carregarAlternativasGerais={carregarAlternativasGerais}
                  showAlert={showAlert}
                  setLoading={setLoading}
                />

                <CampanhaOfertasCliente
                  ofertasCliente={ofertasCliente}
                  alternativasOfertasCliente={alternativasOfertasCliente}
                  abrirNovaOfertaCliente={abrirNovaOfertaCliente}
                  abrirEditarOfertaCliente={abrirEditarOfertaCliente}
                  apagarOfertaCliente={apagarOfertaCliente}
                  abrirNovaAlternativaOfertaCliente={abrirNovaAlternativaOfertaCliente}
                  abrirEditarAlternativaOfertaCliente={abrirEditarAlternativaOfertaCliente}
                  apagarAlternativaOfertaCliente={apagarAlternativaOfertaCliente}
                  alterarReembolsadaOfertaCliente={alterarReembolsadaOfertaCliente}
                />

                <CampanhaBeneficios
                  formBeneficio={formBeneficio}
                  setFormBeneficio={setFormBeneficio}
                  basesCalculoBeneficio={basesCalculoBeneficio}
                  mostrarValorEur={mostrarValorEur}
                  mostrarValorUnidade={mostrarValorUnidade}
                  mostrarPercentagem={mostrarPercentagem}
                  mostrarOferta={mostrarOferta}
                  materiaisCombo={materiaisCombo}
                  carregarMateriaisCombo={carregarMateriaisCombo}
                  materialLabel={materialLabel}
                  ofertaInput={ofertaInput}
                  setOfertaInput={setOfertaInput}
                  guardarBeneficio={guardarBeneficio}
                  beneficios={beneficios}
                  editarBeneficio={editarBeneficio}
                  pedirEliminarBeneficio={pedirEliminarBeneficio}
                />
              </MDBox>
            )}
          </MDBox>
        </DialogContent>

        <DialogActions
          sx={{
            flexWrap: "wrap",
            gap: 1,
            px: { xs: 2, md: 3 },
            pb: { xs: 2, md: 2 },
            "& .MuiButton-root": {
              width: { xs: "100%", sm: "auto" },
            },
          }}
        >
          <MDButton color="secondary" onClick={() => setOpenDialog(false)}>
            Cancelar
          </MDButton>
          <MDButton
            color="success"
            onClick={!editando && campanhaOrigemCopia?.id ? copiarCampanha : guardar}
          >
            {!editando && campanhaOrigemCopia?.id ? "Copiar Campanha" : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <DialogCampanhaMaterial
        PaperComponent={PaperComponent}
        open={openDialogMaterial}
        onClose={fecharDialogMaterial}
        formMaterial={formMaterial}
        setFormMaterial={setFormMaterial}
        materialInput={materialInput}
        setMaterialInput={setMaterialInput}
        materiaisCombo={materiaisCombo}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        guardarMaterial={guardarMaterial}
        form={form}
        materiaisCampanha={materiaisCampanha}
        carregarMateriaisCampanha={carregarMateriaisCampanha}
        showAlert={showAlert}
        setLoading={setLoading}
      />

      <DialogCampanhaMaterialAlternativas
        PaperComponent={PaperComponent}
        open={openDialogAlternativas}
        onClose={fecharDialogAlternativas}
        materialAlternativasSelecionado={materialAlternativasSelecionado}
        formAlternativa={formAlternativa}
        setFormAlternativa={setFormAlternativa}
        alternativaInput={alternativaInput}
        setAlternativaInput={setAlternativaInput}
        materiaisCombo={materiaisCombo}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        alternativasPorMaterial={alternativasPorMaterial}
        guardarAlternativa={guardarAlternativa}
        form={form}
        carregarAlternativasMaterial={carregarAlternativasMaterial}
        showAlert={showAlert}
        setLoading={setLoading}
      />

      <DialogConfirmarEliminarMaterialCampanha
        open={openConfirmDelMaterial}
        onClose={fecharConfirmDelMaterial}
        materialParaEliminar={materialParaEliminar}
        confirmarEliminarMaterial={confirmarEliminarMaterial}
      />

      <DialogConfirmarEliminarBeneficioCampanha
        open={openConfirmDelBeneficio}
        onClose={fecharConfirmDelBeneficio}
        confirmarEliminarBeneficio={confirmarEliminarBeneficio}
        beneficioParaEliminar={beneficioParaEliminar}
      />

      <DialogCampanhaRecebimentos
        open={openRecebimentos}
        onClose={() => setOpenRecebimentos(false)}
        recebimentosForm={recebimentosForm}
        setRecebimentosForm={setRecebimentosForm}
        recebimentosLinhas={recebimentosLinhas}
        setRecebimentosLinhas={setRecebimentosLinhas}
        historicoRecebimentosCampanha={historicoRecebimentosCampanha}
        abrirResultado={abrirResultado}
        gravarRecebimentos={gravarRecebimentos}
        apagarRecebimentoCampanha={apagarRecebimentoCampanha}
        isAdminLike={isAdminLike}
      />

      <DialogCampanhaInfo
        PaperComponent={PaperComponent}
        open={openInfoCampanha}
        onClose={() => setOpenInfoCampanha(false)}
        campanhaSelecionada={campanhaInfo}
        loading={loadingInfoCampanha}
        materiaisCampanha={materiaisCampanha}
        alternativasPorMaterial={alternativasPorMaterial}
        alternativasGerais={alternativasGerais}
        ofertasCliente={ofertasCliente}
        alternativasOfertasCliente={alternativasOfertasCliente}
        beneficios={beneficios}
        filtrosCampanha={filtrosCampanha}
        clientesAcordosCampanha={clientesAcordosCampanha}
      />

      <DialogCampanhaResultados
        PaperComponent={PaperComponent}
        open={openResultadosCampanha}
        onClose={() => setOpenResultadosCampanha(false)}
        campanhaResultados={campanhaResultados}
        periodo={periodoResultadosCampanha}
        setPeriodo={setPeriodoResultadosCampanha}
        totalApurado={resultados.reduce(
          (total, linha) => total + Number(linha?.valor_a_receber || 0),
          0
        )}
        onRecalcular={() => carregarResultados(campanhaResultados?.id, periodoResultadosCampanha)}
        soComAlertas={soComAlertas}
        resultados={
          soComAlertas
            ? resultados.filter(
                (r) =>
                  Number(r.sem_flag_campanha || 0) === 1 ||
                  Number(r.tem_descprom_acima_maximo || 0) === 1 ||
                  Number(r.tem_diferenca_flag_conjuntos || 0) === 1
              )
            : resultados
        }
        resultadosExcluidos={resultadosExcluidos}
        abrirResultado={abrirResultado}
        reintegrarFatura={reintegrarFatura}
        abrirRecusarFatura={abrirRecusarFatura}
        abrirRecebimentos={abrirRecebimentos}
        limparVendedor={limparVendedor}
        loadingResultados={loadingResultados}
        alertasCampanha={alertasCampanha}
        filtroResolucaoAlertas={filtroResolucaoAlertas}
        setFiltroResolucaoAlertas={setFiltroResolucaoAlertas}
        gravarResolucaoAlerta={gravarResolucaoAlerta}
      />

      <DialogCampanhaRecusarFatura
        open={openRecusarFatura}
        onClose={fecharRecusarFatura}
        faturaParaRecusar={faturaParaRecusar}
        motivoRecusaFatura={motivoRecusaFatura}
        setMotivoRecusaFatura={setMotivoRecusaFatura}
        gravarRecusaFatura={gravarRecusaFatura}
      />

      <DialogCampanhaResultadoDetalhe
        PaperComponent={PaperComponent}
        open={openResultado}
        onClose={() => setOpenResultado(false)}
        resultadoSelecionado={resultadoSelecionado}
        resultadoLinhas={resultadoLinhas}
        resultadoBeneficios={resultadoBeneficios}
        limparVendedor={limparVendedor}
      />

      <DialogProcessarCampanhasFabricante
        PaperComponent={PaperComponent}
        open={openProcessarFabricante}
        onClose={async () => {
          setOpenProcessarFabricante(false);
          await carregar();
          setRefreshAposProcessamento(false);
        }}
        fabricantesVigentes={fabricantesVigentes}
        fabricanteVigenteSelecionado={fabricanteVigenteSelecionado}
        setFabricanteVigenteSelecionado={setFabricanteVigenteSelecionado}
        fabricanteVigenteInput={fabricanteVigenteInput}
        setFabricanteVigenteInput={setFabricanteVigenteInput}
        diagnosticoFabricante={diagnosticoFabricante}
        processamentosCampanhas={processamentosCampanhas}
        carregarDiagnosticoFabricante={carregarDiagnosticoFabricante}
        processarCampanhasFabricante={processarCampanhasFabricante}
      />

      <DialogCampanhaEmailFabricante
        PaperComponent={PaperComponent}
        open={openDialogEmail}
        onClose={() => setOpenDialogEmail(false)}
        emailForm={emailForm}
        setEmailForm={setEmailForm}
        loadingAnexoEmail={loadingAnexoEmail}
        descarregarAnexoReembolso={descarregarAnexoReembolso}
        enviarEmailReembolso={enviarEmailReembolso}
      />

      <DialogCampanhaOfertaCliente
        PaperComponent={PaperComponent}
        open={openDialogOfertaCliente}
        onClose={fecharDialogOfertaCliente}
        formOfertaCliente={formOfertaCliente}
        setFormOfertaCliente={setFormOfertaCliente}
        ofertaInput={ofertaInput}
        setOfertaInput={setOfertaInput}
        materiaisCombo={materiaisCombo}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        guardarOfertaCliente={guardarOfertaCliente}
        form={form}
        carregarOfertasCliente={carregarOfertasCliente}
        showAlert={showAlert}
        setLoading={setLoading}
      />

      <DialogCampanhaOfertaAlternativas
        PaperComponent={PaperComponent}
        open={openDialogOfertaClienteAlternativas}
        onClose={() => setOpenDialogOfertaClienteAlternativas(false)}
        ofertaClienteAlternativasSelecionada={ofertaClienteAlternativasSelecionada}
        alternativasOfertasCliente={alternativasOfertasCliente}
        formOfertaClienteAlternativa={formOfertaClienteAlternativa}
        setFormOfertaClienteAlternativa={setFormOfertaClienteAlternativa}
        alternativaInput={alternativaInput}
        setAlternativaInput={setAlternativaInput}
        materiaisCombo={materiaisCombo}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        guardarOfertaClienteAlternativa={guardarOfertaClienteAlternativa}
        abrirEditarAlternativaOfertaCliente={abrirEditarAlternativaOfertaCliente}
        apagarAlternativaOfertaCliente={apagarAlternativaOfertaCliente}
      />

      <DialogCampanhasAlertasEditar
        PaperComponent={PaperComponent}
        open={openEditarAlertas}
        onClose={() => setOpenEditarAlertas(false)}
        alertas={alertasTodos}
        loading={loadingEditarAlertas}
        limparVendedor={limparVendedor}
        gravarResolucaoAlerta={gravarResolucaoAlerta}
        recarregarAlertas={carregarTodosAlertas}
      />

      <Dialog
        open={openConfirmDelCampanha}
        onClose={fecharEliminarCampanha}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Apagar campanha</DialogTitle>

        <DialogContent>
          <MDTypography>Tem a certeza que pretende apagar a campanha:</MDTypography>

          <MDTypography fontWeight="bold" mt={1}>
            {campanhaParaEliminar?.nome}
          </MDTypography>

          <MDTypography mt={2} color="error">
            Esta operação irá remover também todos os resultados, alertas, emails e processamentos
            associados.
          </MDTypography>
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={fecharEliminarCampanha}>
            Cancelar
          </MDButton>

          <MDButton color="error" onClick={confirmarEliminarCampanha}>
            Apagar
          </MDButton>
        </DialogActions>
      </Dialog>

      <DialogCampanhaConsultaFatura
        PaperComponent={PaperComponent}
        open={openConsultaFatura}
        onClose={() => setOpenConsultaFatura(false)}
        faturaConsulta={faturaConsulta}
        setFaturaConsulta={setFaturaConsulta}
        resultados={resultadosConsultaFatura}
        loading={loadingConsultaFatura}
        onConsultar={consultarBeneficiosFatura}
      />
    </DashboardLayout>
  );
}
